<template>
  <div class="not-found">
    <h1>Sorry, Not Found!</h1>
    <img src="../../assets/404.png" alt="Not Found!">
  </div>
</template>

<script>
export default {
  name: 'NotFound'
};
</script>

<style lang="scss" scoped src="./style.scss"></style>



// WEBPACK FOOTER //
// src/pages/NotFound/index.vue